import { apiClient, unwrap } from './client';
import type { ApiSuccess } from '@/types/api';
import type { User, Address, AddressInput } from '@/types/user';

export const usersApi = {
  async getMe(): Promise<User> {
    const res = await apiClient.get<ApiSuccess<User>>('/users/me');
    return unwrap(res);
  },

  async updateMe(input: Partial<Pick<User, 'name' | 'phone'>>): Promise<User> {
    const res = await apiClient.patch<ApiSuccess<User>>('/users/me', input);
    return unwrap(res);
  },

  async deleteMe(): Promise<void> {
    await apiClient.delete('/users/me');
  },

  async listAddresses(): Promise<Address[]> {
    const res = await apiClient.get<ApiSuccess<Address[]>>('/users/me/addresses');
    return unwrap(res);
  },

  async createAddress(input: AddressInput): Promise<Address> {
    const res = await apiClient.post<ApiSuccess<Address>>(
      '/users/me/addresses',
      input
    );
    return unwrap(res);
  },

  async updateAddress(id: number, input: Partial<AddressInput>): Promise<Address> {
    const res = await apiClient.patch<ApiSuccess<Address>>(
      `/users/me/addresses/${id}`,
      input
    );
    return unwrap(res);
  },

  async deleteAddress(id: number): Promise<void> {
    await apiClient.delete(`/users/me/addresses/${id}`);
  },
};
